export class RGBColor {
    r: number;
    g: number;
    b: number;

    constructor(r: number = 0,
                g: number = 0,
                b: number = 0) {
        this.r = r;
        this.g = g;
        this.b = b;
    }

    public hex(): string {
        return "#" + ((1 << 24) + (this.r << 16) + (this.g << 8) + this.b).toString(16).slice(1);
    }

    public rgb(): string {
        return `rgb(${this.r},${this.g},${this.b})`
    }

    getValue(): [number, number, number] {
        return [this.r, this.g, this.b];
    }
}

/**
 * @author otunctan
 */

export class ImageProcessing {


    static getAverageRGB(imageElement: HTMLImageElement): RGBColor {
        let defaultRGB = new RGBColor(0, 0, 0),
            canvas = document.createElement('canvas'),
            context: CanvasRenderingContext2D | null = canvas && canvas.getContext('2d'),
            imageData, width, height,
            length,
            rgb: RGBColor = defaultRGB,
            count = 0;

        if (!context) {
            return defaultRGB;
        }

        height = canvas.height = imageElement.naturalHeight || imageElement.offsetHeight || imageElement.height;
        width = canvas.width = imageElement.naturalWidth || imageElement.offsetWidth || imageElement.width;

        context.drawImage(imageElement, 0, 0, width, height);

        try {
            imageData = context.getImageData(0, 0, width, height);
        } catch (e) {
            console.error(e);
            return defaultRGB;
        }

        length = imageData.data.length;

        for (let i = 0; i < length; i += 4) {
            ++count;
            rgb.r += imageData.data[i];
            rgb.g += imageData.data[i + 1];
            rgb.b += imageData.data[i + 2];
        }

        // ~~ used to floor values
        rgb.r = ~~(rgb.r / count);
        rgb.g = ~~(rgb.g / count);
        rgb.b = ~~(rgb.b / count);

        return rgb;
    }


}
